import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { testMatchCheck } from '~/services/ClaimCampaignService';

import { type MatchCheckDefinition } from '~/types/claimCampaignTypes';

interface TestMatchCheckParams {
  bqQuery: string;
  checks: Array<MatchCheckDefinition>;
  customerId: string;
}

/**
 * Runs a dry-run match-check with a BQ query and eligibility checks.
 */
export function useTestMatchCheck() {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (params: TestMatchCheckParams) => {
      return await testMatchCheck(params);
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Match check failed: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
